import React, { FC } from 'react'
import { Quote, renderQuoteList } from './QuoteList'
import { SlideshowTimer, Timers } from './Slideshow/ControlledSlideshowNavigation'
import { SlideshowBox } from './Slideshow/SlideshowBox'

const defaultSlideDuration = Timers.ShortInterval

export interface QuoteSlideshowBoxProps {
  additionalClassName?: string

  /** How long each slide should be displayed by default, in seconds, if more than one quote (optional, defaults to 5) */
  interval?: SlideshowTimer

  /** One or more quotes to display (results in slideshow if more than 1) */
  quotes: Quote[]
}

export const QuoteSlideshowBox: FC<QuoteSlideshowBoxProps> = ({
  additionalClassName,
  interval,
  quotes,
}) => {
  if (!quotes?.length) {
    return null
  }

  return (
    <SlideshowBox
      additionalClassName={additionalClassName}
      as="aside"
      timer={interval ?? defaultSlideDuration}
      variant={'border-shade'}
    >
      {renderQuoteList({
        disableGutter: true,
        quotes,
      })}
    </SlideshowBox>
  )
}
